// import React from "react";

// export const Logo = ({ size = 28, withWordmark = true, light = false }) => {
//   const fg = light ? "#fff" : "#1c1c1c";
//   return (
//     <div className="flex items-center gap-2" data-testid="zq-logo">
//       <div
//         className="rounded-md flex items-center justify-center"
//         style={{ background: "#F97316", width: size + 8, height: size + 8 }}
//       >
//         <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
//           <rect x="2" y="2" width="7" height="7" rx="1.4" stroke="white" strokeWidth="1.6" />
//           <rect x="15" y="2" width="7" height="7" rx="1.4" stroke="white" strokeWidth="1.6" />
//           <rect x="2" y="15" width="7" height="7" rx="1.4" stroke="white" strokeWidth="1.6" />
//           <path d="M16 17l1.7 1.7L22 14.5" stroke="white" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
//           <path d="M16 21c1.4-.6 2.4-1.6 3-3" stroke="white" strokeWidth="1.6" strokeLinecap="round" />
//         </svg>
//       </div>
//       {withWordmark && (
//         <div className="leading-tight">
//           <div className="text-lg font-bold" style={{ color: fg }}>
//             Zayka<span style={{ color: "#F97316" }}>QR</span>
//           </div>
//           <div className="text-[9px] tracking-[0.18em] uppercase" style={{ color: light ? "#cbd5e1" : "#6b7280" }}>
//             Digital Menu System
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

import React from "react";

export const Logo = ({ size = 28, withWordmark = true, light = false }) => {
  const fg = light ? "#fff" : "#1c1c1c";
  return (
    <div className="flex items-center gap-2" data-testid="zq-logo">
      <img
        src="/logo.png"
        alt="ZaykaQR Logo"
        style={{ width: size + 8, height: size + 8, objectFit: "contain" }}
      />
      {withWordmark && (
        <div className="leading-tight">
          <div className="text-lg font-bold" style={{ color: fg }}>
            Zayka<span style={{ color: "#F97316" }}>QR</span>
          </div>
          <div
            className="text-[9px] tracking-[0.18em] uppercase"
            style={{ color: light ? "#cbd5e1" : "#6b7280" }}
          >
            Digital Menu System
          </div>
        </div>
      )}
    </div>
  );
};